import { getToken } from "@/utils/auth";
import { xjLogin, createScreenTicket } from "@/api/system1/user";
export default {
  name: "LoginCommon",
  data() {
    return {
      audioSrc: "/mz_read.mp3",
      bigScreenUrl: window.g.VUE_APP_BIG_SCREEN_URL,
      isPlaying: false
    };
  },
  mounted() {
    // 尝试自动播放音频
    this.$nextTick(() => {
      if (this.$refs.audioPlayer) {
        this.$refs.audioPlayer.play().catch(err => {
          console.log("音频自动播放失败，需要用户交互:", err);
        });
      }
    });
  },
  methods: {
    buildScreenEntryUrl(ticket) {
      try {
        const url = new URL(this.bigScreenUrl, window.location.origin);
        url.hash = `/screen-entry?ticket=${encodeURIComponent(ticket)}`;
        return url.toString();
      } catch (error) {
        const [baseUrl] = this.bigScreenUrl.split("#");
        return `${baseUrl}#/screen-entry?ticket=${encodeURIComponent(ticket)}`;
      }
    },
    //获取公钥
    xjLoginFn() {
      xjLogin().then(response => {
        // if (response.code == 0) {
        //   this.publicKey = response.data
        // }
      });
    },
    // 切换音频播放/暂停
    toggleAudio() {
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      if (this.isPlaying) {
        audio.pause();
      } else {
        audio.play().catch(err => {
          console.log("音频播放失败:", err);
        });
      }
    },
    // 处理音频加载错误
    handleAudioError() {
      console.warn("音频加载失败");
      // this.audioSrc = null;
    },
    // 管网综合态势
    async enterPipelineStatus() {
      const token = getToken();
      if (!token) {
        this.$router.push("/login");
        return;
      }
      const screenWindow = window.open("about:blank", "_blank");
      try {
        const response = await createScreenTicket();
        const ticket = response?.data?.ticket;
        if (!ticket) {
          throw new Error("未获取到大屏访问票据");
        }
        const url = this.buildScreenEntryUrl(ticket);
        if (screenWindow) {
          screenWindow.location.replace(url);
          return;
        }
        window.open(url, "_blank");
      } catch (error) {
        if (screenWindow) {
          screenWindow.close();
        }
        this.$message.error(error?.msg || error?.message || "进入大屏失败");
      }
    },
    // 综合管理平台
    enterManagePlatform() {
      this.$router.push("/");
    },
    // 燃气巡检平台
    enterInspectionPlatform() {
      // this.xjLoginFn();
      window.open('https://account.mps.tianlungas.com', "_blank");
      // this.$message.closeAll();
      // this.$message.warning("功能开发中，敬请期待！");
    }
  }
};